import { createFuncall } from 'vue-funcall'

import ImagePreview from './ImagePreview.vue'

export { default as ImagePreview } from './ImagePreview.vue'

export const showImagePreview = ({ images = [], startPosition = 0, options, ...props }) => {
  const { close } = createFuncall(ImagePreview, {
    show: true,
    images,
    startPosition,
    transitionAppear: true,
    onClosed () {
      close()
    },
    ...props
  }, options)

  return { close }
}
